import { type ReduxStateShared } from '~shared/types';

/**
 * When we send state to third party services, we want to strip it of PHI.
 * This function only allows specific state keys, which protects against later adding new
 * keys that contain PHI.
 */
export const getPHIFilteredState = (state: ReduxStateShared) => ({
  auth: { loggedInAt: state.auth.loggedInAt, authorized: state.auth?.authorized },
  addresses: { addresses: state.addresses.addresses.map(({ id }) => ({ id })) },
  analytics: {
    events: state.analytics.events.map(({ id, key, occurredAt, properties }) => ({
      id,
      key,
      occurredAt,
      properties,
    })),
    flushing: state.analytics.flushing,
    lastFlushAttemptedAt: state.analytics.lastFlushAttemptedAt,
    consecutiveFlushFailures: state.analytics.consecutiveFlushFailures,
  },
  appTime: state.appTime,
  checkout: state.checkout,
  deliveries: {
    deliveries: state.deliveries.deliveries.map(({ created_at, id, status }) => ({ created_at, id, status })),
    // @ts-expect-error Property  does not exist on type 'ReduxStateShared'
    windows: state.deliveries?.windows,
  },
  // Insurance records live in React Query cache, not Redux.
  insurances: {
    insurances: [] as number[],
  },
  modal: state.modal,
  notices: state.notices,
  paymentMethods: { paymentMethods: state.paymentMethods.paymentMethods.map(({ id }) => ({ id })) },
  prescriptions: {
    prescriptions: state.prescriptions.prescriptions.map(({ id }) => ({ id })),
    transfers: state.prescriptions.transfers?.map(({ id }) => ({ id })) ?? [],
  },
  presence: state.presence,
  shipments: { shipments: state.shipments.shipments.map(({ id }) => ({ id })) },
  ui: {
    actionSheet: { key: state.ui.actionSheet?.key },
    cart: state.ui.cart,
    loading: state.ui.loading,
    errors: state.ui.errors,
    users: state.ui.users,
    medications: state.ui.medications,
  },
  uiOnboarding: {
    isSignupLoading: state.uiOnboarding?.isSignupLoading,
    isCurrentUserLoading: state.uiOnboarding?.isCurrentUserLoading,
    isOnboarding: state.uiOnboarding?.isOnboarding,
  },
  users: {
    currentUserID: state.users.currentUserID,
    users: state.users.users.map(({ id, created_at, updated_at }) => ({ id, created_at, updated_at })),
  },
});
